<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MaUserDialog',
})
</script>
<template>
	<ma-data-table
		:key="visible + ''"
		v-model:visible="visible"
		row-key="id"
		:title="t('maComponents.user.selectUser')"
		url="/sys/user/pageOnline"
		:multiple="true"
		:default-selected="defaultSelected"
		:columns="[
			{ field: 'id', label: t('maComponents.user.username') + 'ID' },
			{ field: 'username', label: t('maComponents.user.username') },
			{ field: 'realName', label: t('maComponents.user.realName') },
			{ field: 'orgName', label: t('maComponents.org.orgName') },
			{ field: 'mobile', label: t('maComponents.pleaseInput') + t('maComponents.user.mobile') },
			{ field: 'createTime', label: t('maComponents.user.createTime') }
		]"
		:query-params="[
			{ field: 'username', label: t('maComponents.user.username'), type: 'input' },
			{ field: 'mobile', label: t('maComponents.pleaseInput') + t('maComponents.user.mobile'), type: 'input' },
			{ field: 'realName', label: t('maComponents.user.realName'), type: 'input' },
			{ field: 'orgId', label: t('maComponents.org.orgName'), type: 'org' }
		]"
		@select="onSelect"
	></ma-data-table>
</template>

<script setup lang="ts" name="MaUserDialog">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps({
	multiple: {
		type: Boolean,
		required: false,
		default: true
	},
	defaultSelected: {
		type: Array,
		required: false,
		default: () => []
	}
})

const visible = defineModel<boolean>()

const emit = defineEmits(['select'])
const onSelect = (rows: any[]) => {
	emit('select', rows)
}
</script>
